import {observer} from 'mobx-react';
import React from 'react';
import s from '../s';

const ShareIcon: React.FC = observer(() => {
    const canShare = typeof navigator !== 'undefined' && !!navigator.share;

    return (
        canShare &&
        s.isRetail && (
            <button
                type="button"
                className="share-button"
                aria-label="Share"
                onClick={s.share}
            >
                <i
                    className="fas fa-share-square"
                    aria-hidden={true}
                />
            </button>
        )
    );
});

export default ShareIcon;
